import { Box, Typography } from '@mui/material';
import React from 'react';
import { NavRow } from '../../generic/NavRow';

interface ISignatureCertificationStartProps {
  handleBack: () => void;
  handleNext: () => void;
}

export const SignatureCertificationStart: React.FC<
  ISignatureCertificationStartProps
> = props => {
  return (
    <Box>
      <Box sx={{ mt: 5 }} />
      <Typography variant='h4' sx={{ mb: 3 }}>
        Unterschriftsbeglaubigung
      </Typography>

      <Typography>
        Herzlich Willkommen!
        <br />
        Mit Hilfe unseres Dialogs können Sie die Beglaubigung Ihrer Unterschrift
        vorbereiten.
        <p />
        Brauchen Sie zwischendurch eine Pause? Sie können Ihre Eingaben
        jederzeit über das Feld <i>Sichern</i> exportieren und speichern. Setzen
        Sie Ihre Eingaben dann über die Klickfläche <i>Wiederherstellung</i>{' '}
        fort.
      </Typography>

      <NavRow
        handleBack={props.handleBack}
        handleNext={props.handleNext}
        hideBackButton
      />
    </Box>
  );
};
